
<ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
